import axios from "axios";
import { COURSE_SERVICE_URL, getHeaders } from "@/apis/common";

export function getCourseRatingAttributeCategories(token) {
  const url = `${COURSE_SERVICE_URL}/private/course-rating-attribute-category`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}

export function getCourseRatingAttributes(token) {
  const url = `${COURSE_SERVICE_URL}/private/course-rating-attribute`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}

export function getCourseRatingAttributesMeta(token) {
  const promises = [
    getCourseRatingAttributeCategories(token),
    getCourseRatingAttributes(token),
  ];

  return Promise.all(promises);
}

export function addCourseRating(token, payload) {
  /**
   * expected payload:
   * {
   *  "uid": "ofMNG83S5Ogjj7fNDtCZzL6C3Tk1",
   *  "courseId": "US000067",
   *  "datePlayed": "2021-05-12T17:20:18.543Z",
   *  "recommendToFriend": true,
   *  "UserCourseReview_CourseRatings": [
   *    {
   *      "courseRatingAttributeId": 1,
   *      "rating": 8
   *    },
   *    ...
   *  ]
   * }
   */
  const url = `${COURSE_SERVICE_URL}/private/course-review`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.post(url, payload, config).then(res => res.data);
}

export function getCourseRatingAggsByCourseIdAndCourseRatingAttributeId(
  token,
  courseId,
  courseRatingAttributeId,
) {
  const url = `${COURSE_SERVICE_URL}/private/course-review/aggs/${courseId}/${courseRatingAttributeId}`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}

export function getAllCourseRatings(token) {
  const url = `${COURSE_SERVICE_URL}/private/course-review`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}

export function getAllCourseRatingsByUid(token) {
  const url = `${COURSE_SERVICE_URL}/private/course-reviews`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}

export function getCourseRatingAggsByCourseId(courseId) {
  const url = `${COURSE_SERVICE_URL}/public/course-review/aggs/${courseId}`;

  return fetch(url, {
    headers: getHeaders(),
  }).then(response => response.json());
}

export function getAllAggs() {
  const url = `${COURSE_SERVICE_URL}/public/course-review-aggs`;
  const headers = getHeaders();
  const config = {
    headers,
  };

  return axios
    .get(url, config)
    .then(res => res.data)
    .then(aggs => {
      var transformed = aggs.map(d => {
        var { name } = d;
        var newResults = d.results.map(r => {
          var newResult = {
            courseId: r.courseId,
          };

          ["count", "min", "max", "avg"].forEach(aggType => {
            var n = aggType[0].toUpperCase() + aggType.slice(1);

            newResult[`rating${name}${n}`] = Number(r[aggType]);
          });

          return newResult;
        });

        return {
          name,
          results: newResults,
        };
      });
      return transformed;
    });
}

export function getAllUserCourseReviewAggs(token) {
  const url = `${COURSE_SERVICE_URL}/private/course-reviews/aggs`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}

export function getCourseRatingsByCourseId(courseId) {
  const url = `${COURSE_SERVICE_URL}/public/course/${courseId}/reviews`;

  return fetch(url, {
    headers: getHeaders(),
  }).then(response => response.json());
}

export function getReviewsCourseIdsByUid(token) {
  const url = `${COURSE_SERVICE_URL}/private/user-course-reviews-courses`;
  const headers = getHeaders(token);
  const config = {
    headers,
  };

  return axios.get(url, config).then(res => res.data);
}
